import { Card, Flex, Tooltip } from 'antd';
import styles from './insights-card.module.scss';
import InfoCircleIcon from '@/assets/icons/info-circle.svg?react';
import { ReactNode } from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';

interface InsightsCardProps {
  title: string;
  tooltip?: string;
  children: ReactNode;
  isLoading?: boolean;
}

export default function InsightCard({ title, tooltip, isLoading, children }: InsightsCardProps) {
  return (
    <Card
      rootClassName={styles.insightsCard}
      classNames={{ body: styles.insightsCardBody }}
      loading={isLoading}
    >
      <Flex className={styles.insightsCardContainer}>
        <Flex className={styles.insightsCardsHeader}>
          <span>{title}</span>
          <Tooltip title={tooltip}>
            <Icon
              component={() => <InfoCircleIcon className={styles.insightsCardsInfoIcon} />}
            ></Icon>
          </Tooltip>
        </Flex>

        {children}
      </Flex>
    </Card>
  );
}
